import {SessionStorageObject} from './SessionStorageObject';

export class SessionStorageUtility {
  static load<T extends SessionStorageObject>(key: string, instance: T): T | null {
    const objectInStorage = sessionStorage.getItem(key);
    if (objectInStorage) {
      const data = {
        'key': key,
        'data': objectInStorage,
      };
      const event = new CustomEvent('session_storage_load', { detail: data });
      window.dispatchEvent(event);
      return instance.fromStorage(JSON.parse(objectInStorage));
    }
    return null;
  }

  static loadList<T extends SessionStorageObject>(key: string, instance: T): T[] | null {
    const objectInStorage = sessionStorage.getItem(key);
    if (objectInStorage) {
      const data = {
        'key': key,
        'data': objectInStorage,
      };
      const event = new CustomEvent('session_storage_load', { detail: data });
      window.dispatchEvent(event);
      const objectsInStorage = JSON.parse(objectInStorage);
      return objectsInStorage.map(o => instance.fromStorage(o));
    }
    return null;
  }

  static delete(key: string): void {
    const data = {
      'key': key,
      'data': sessionStorage.getItem(key),
    };
    const event = new CustomEvent('session_storage_delete', { detail: data });
    window.dispatchEvent(event);
    sessionStorage.removeItem(key);
  }

  static set<T extends SessionStorageObject>(key: string, object: T) {
    const data = {
      'key': key,
      'data': object,
    };
    const event = new CustomEvent('session_storage_set', { detail: data });
    window.dispatchEvent(event);
    sessionStorage.setItem(key, JSON.stringify(object));
  }

  static setList<T extends SessionStorageObject>(key: string, objects: T[]) {
    const data = {
      'key': key,
      'data': objects,
    };
    const event = new CustomEvent('session_storage_set', { detail: data });
    window.dispatchEvent(event);
    sessionStorage.setItem(key, JSON.stringify(objects));
  }

  static setPrimitive(key: string, object: string | number | boolean | null) {
    const data = {
      'key': key,
      'data': object,
    };
    const event = new CustomEvent('session_storage_set_primitive', { detail: data });
    window.dispatchEvent(event);
    sessionStorage.setItem(key, JSON.stringify(object));

  }

  static loadPrimitive(key: string): string | number | boolean | null {
    const item = sessionStorage.getItem(key);
    if (item) {
      const data = {
        'key': key,
        'data': item,
      };
      const event = new CustomEvent('session_storage_load_primitive', { detail: data });
      window.dispatchEvent(event);

      try {
        return JSON.parse(item);
      } catch (e) {
        return item;
      }
    }
    return null;
  }
}
